import {FC} from 'react'
import {useFormContext} from 'react-hook-form'
import {Section} from 'jbc-front/components/presenters/form/Section'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import {DateField} from 'components/reactHookForm/DateField'
import {FormErrors} from 'components/reactHookForm/FormErrors'
import {OfficeSelectField} from 'components/reactHookForm/OfficeSelectField/OfficeSelectField'
import {Schema} from './schema'

export const Form: FC = () => {
  const {
    formState: {errors, isSubmitting},
  } = useFormContext<Schema>()

  return (
    <div className="basic_information">
      <FormErrors errors={errors} isSubmitting={isSubmitting} />

      <Section title="事業所変更情報">
        <OfficeSelectField
          label="転勤前の事業所"
          error={errors.beforeOfficeId?.message}
          required
          filterByCurrentOffices
          name="beforeOfficeId"
        />

        <Spacer size={20} />

        <OfficeSelectField
          label="転勤後の事業所"
          error={errors.afterOfficeId?.message}
          required
          filterByCurrentOffices
          name="afterOfficeId"
        />

        <Spacer size={20} />

        <DateField label="転勤年月日" required error={errors.relocateOn?.message} name="relocateOn" />
      </Section>
    </div>
  )
}
